export const parseDate = (dateString: string) => {
  const parsedDate = new Date(dateString);
  const year = parsedDate.toLocaleString("en-US", { year: "numeric" });
  const month = parsedDate.toLocaleString("en-US", {
    month: "2-digit",
  });
  const day = parsedDate.toLocaleString("en-US", { day: "2-digit" });
  return [month, day, year].join("/");
};
